var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrolldown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "#272935"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 319 c-15 -8 -18 -25 -18 -114 0 -115 9 -135 60 -135 51 0 60 20 60 130 0 76 -4 102 -16 114 -17 18 -60 20 -86 5z m64 -56 c10 -9 18 -21 18 -26 0 -6 -9 -2 -20 8 -19 17 -21 17 -38 2 -29 -26 -38 -20 -12 8 28 30 28 30 52 8z m-40 -110 c17 -15 19 -15 38 2 11 10 20 14 20 8 0 -5 -9 -18 -20 -28 -20 -18 -21 -18 -48 8 -29 29 -21 38 10 10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolldown);
export default __webpack_public_path__ + "static/media/scrolldown.2d55a70f06c960b050b26c6e3f527ac8.svg";
export { ForwardRef as ReactComponent };